<style lang="scss" src='./Settings.scss' scoped ></style>
<template src="./Settings.html"></template>
<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Profile from './components/profile/Profile.vue';
import GolfCourse from './components/golfCourse/GolfCourse.vue';
import ChangePassword from './components/changePassword/ChangePassword.vue';
import Notifications from './components/notifications/Notifications.vue';
import Monitor from './components/monitor/Monitor.vue';
import Support from './components/support/Support.vue';
import Newsletter from './components/newsletter/Newsletter.vue';
import { mapState, mapMutations, } from 'vuex';

export default {
  name: 'Settings',
  extends: SecurityComponent,
  components: {
    Profile,
    GolfCourse,
    ChangePassword,
    Notifications,
    Monitor,
    Support,
    Newsletter,
  },
  data() {
    return {
      tabs: this.getTabs(),
    };
  },
  computed: {
    ...mapState('Settings', ['currentTab']),
  },
  methods: {
    ...mapMutations('Settings', ['setCurrentTab']),
  },
  created(){
    if(this.$route.query.tab){
      this.setCurrentTab(this.$route.query.tab);
    } else {
      this.setCurrentTab('GolfCourse');
    }
  },
  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings");
      this.$analytics.logEvent("web_settings");
    }
  },

};
</script>
